import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Api } from '../../services/api';
import { A11yModule } from "@angular/cdk/a11y"; 

@Component({
  selector: 'app-mdl-create-user',
  standalone: true,
  imports: [CommonModule, FormsModule, A11yModule],
  templateUrl: './mdl-create-user.html',
  styleUrls: ['./mdl-create-user.css']
})
export class MdlCreateUserComponent implements OnInit{
  userRequest: any = {
    rut: '',
    nombre: '',
    apellido: '',
    email: '',
    contrasena: '', 
    cargo: '',
    rolId: '',
    activo: 1 
  };

  rutFormateado: string = ''; 
  confirmarContrasena: string = '';
  apodo: string = '';
  alias: string = '';
  nombreUsuario: string = '';
  mostrarContrasena: boolean = false;
  mostrarConfirmarContrasena: boolean = false;

  rolesDisponibles: any[] = [];

  constructor(
    private api: Api,
    public dialogRef: MatDialogRef<MdlCreateUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  closeMdl() {
    this.dialogRef.close(false);
  }

  ngOnInit(): void {
    this.getRoles()
  }

  createUser() {
    
    this.userRequest.activo = Number(this.userRequest.activo);
    
    
    if (!this.userRequest.rut || !this.userRequest.nombre || !this.userRequest.apellido || 
      !this.userRequest.email  || !this.userRequest.rolId || 
      this.userRequest.activo === undefined) {
      alert('Por favor, complete todos los campos obligatorios');
      return;
    }
    
    if (!this.userRequest.contrasena) {
      this.generarContrasenaAutomatica();
    }

    this.api.showLoading();

    this.api.createUser(this.userRequest).subscribe({
      next: (response: any) => {
        this.api.hideLoading();
        alert('Usuario creado exitosamente');
        this.dialogRef.close(true);
      },
      error: (error: any) => {
     
        this.api.hideLoading();
        
        let errorMessage = 'Error al crear usuario';
        
        if (error.status === 400) {
          errorMessage = error.error?.message || 'Datos inválidos. Verifica la información.';
        } else if (error.status === 500) {
          errorMessage = 'Error del servidor. Contacta al administrador.';
        }
        
        alert(errorMessage);   
        this.dialogRef.close(false);
      }
    });
  }

  manejarTecladoRut(event: KeyboardEvent) {
    const teclasPermitidas = [
      '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 
      'k', 'K', 
      'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'
    ];
    
    if (!teclasPermitidas.includes(event.key)) {
      event.preventDefault();
    }
  }

formatearRut(event: any) {
  const input: HTMLInputElement = event.target;
  let valor = input.value
    .replace(/\./g, '')
    .replace(/-/g, '')
    .toUpperCase()
    .replace(/[^0-9K]/g, '');

  if (valor.length > 9) valor = valor.slice(0, 9);

  if (!valor) {
    this.rutFormateado = '';
    this.userRequest.rut = '';
    input.value = '';
    return;
  }

  const cuerpo = valor.slice(0, -1);
  const dv = valor.slice(-1);

  if (valor.length === 1) {
    this.rutFormateado = valor;
    this.userRequest.rut = valor;  // sin guión aún
    input.value = this.rutFormateado;
    setTimeout(() => input.setSelectionRange(this.rutFormateado.length, this.rutFormateado.length), 0);
    return;
  }

  const cuerpoFormateado = cuerpo.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  this.rutFormateado = `${cuerpoFormateado}-${dv}`;
  this.userRequest.rut = `${cuerpo}-${dv}`;

  input.value = this.rutFormateado;
  setTimeout(() => {
    const pos = this.rutFormateado.length;
    input.setSelectionRange(pos, pos);
  }, 0);
}


  toggleMostrarContrasena() {
    this.mostrarContrasena = !this.mostrarContrasena;
  }

  toggleMostrarConfirmarContrasena() {
    this.mostrarConfirmarContrasena = !this.mostrarConfirmarContrasena;
  }

  actualizarCamposVirtuales() {
    if (this.userRequest.nombre && this.userRequest.apellido) {
      const primeraLetraNombre = this.userRequest.nombre.charAt(0).toLowerCase();
      const apellidoCompleto = this.userRequest.apellido.toLowerCase().replace(/\s+/g, '');
      this.apodo = primeraLetraNombre + apellidoCompleto;
      this.alias = primeraLetraNombre + apellidoCompleto;
      
      this.generarContrasenaAutomatica();
    }
  }

  generarContrasenaAutomatica() {
    if (!this.userRequest.nombre || !this.userRequest.apellido) {
      return;
    }

    const caracteresEspeciales = '!@#$%&*';
    const primeraLetraNombre = this.userRequest.nombre.charAt(0).toUpperCase(); // Mayúscula
    const restoNombre = this.userRequest.nombre.substring(1, 3).toLowerCase();
    const dosLetrasApellido = this.userRequest.apellido.substring(0, 2).toLowerCase();
    const numeroAleatorio = Math.floor(Math.random() * 90) + 10; // 10-99
    const caracterEspecial = caracteresEspeciales.charAt(
      Math.floor(Math.random() * caracteresEspeciales.length)
    );

    this.userRequest.contrasena = 
      primeraLetraNombre +  // 1 mayúscula
      restoNombre +         // 2 letras minúsculas
      dosLetrasApellido +   // 2 letras minúsculas  
      numeroAleatorio +     // 2 números
      caracterEspecial;     // 1 carácter especial
    
    this.confirmarContrasena = this.userRequest.contrasena;
  }

  actualizarNombreUsuario() {
    this.nombreUsuario = this.userRequest.email;
    this.actualizarCamposVirtuales(); 
  }

  getRoles(){
    this.api.getRol().subscribe({
      next: (response: any) => {
        this.rolesDisponibles=response.roles
      }})
  }


}